var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */
import { AuthSdkError } from '../errors';
import { isAccessToken, isIDToken } from '../types';
import { getWithoutPrompt } from './getWithoutPrompt';
import { renewTokensWithRefresh } from './renewTokensWithRefresh';
function throwInvalidTokenError() {
    throw new AuthSdkError('Renew must be passed a token with an array of scopes and an accessToken or idToken');
}
// Multiple tokens may have come back. Return only the token which was requested.
function getSingleToken(originalToken, tokens) {
    if (isIDToken(originalToken)) {
        return tokens.idToken;
    }
    if (isAccessToken(originalToken)) {
        return tokens.accessToken;
    }
    throwInvalidTokenError();
}
// If we have a refresh token, renew using that, otherwise getWithoutPrompt
export function renewToken(sdk, token) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!isIDToken(token) && !isAccessToken(token)) {
            throwInvalidTokenError();
        }
        let tokens = sdk.tokenManager.getTokensSync();
        if (tokens.refreshToken) {
            tokens = yield renewTokensWithRefresh(sdk, {
                scopes: token.scopes,
            }, tokens.refreshToken);
            return getSingleToken(token, tokens);
        }
        var responseType;
        if (sdk.options.pkce) {
            responseType = 'code';
        }
        else if (isAccessToken(token)) {
            responseType = 'token';
        }
        else {
            responseType = 'id_token';
        }
        const { scopes, authorizeUrl, userinfoUrl, issuer } = token;
        return getWithoutPrompt(sdk, {
            responseType,
            scopes,
            authorizeUrl,
            userinfoUrl,
            issuer
        })
            .then(function (res) {
            return getSingleToken(token, res.tokens);
        });
    });
}
